import { render, staticRenderFns } from "./user-edit.view.vue?vue&type=template&id=5ca4b4d9&"
import script from "./user-edit.view.ts?vue&type=script&lang=js&"
export * from "./user-edit.view.ts?vue&type=script&lang=js&"
import style0 from "./user-edit.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports